import UIComponent from "../../../ui/component";

export class PaymentSuccessBlock extends UIComponent {
    constructor(element) {
        super(element);
        this.successData = null;
    }

    init() {
        try {
            this.primaryBtn = this.find(".payment-success-footer .btn-primary");
            this.secondaryBtn = this.find(".payment-success-footer .btn-outline-secondary");

            if (this.primaryBtn) {
                this.primaryBtn.addEventListener("click", () =>this.onPrimaryButtonClick());
            }

            if (this.secondaryBtn) {
                this.secondaryBtn.addEventListener("click", () =>this.onSecondaryButtonClick()
);
            }
        } catch (error) {
            console.error("PaymentSuccessBlock init error:", error);
        }
    }

    handlePaymentSuccess(successData) {
        this.successData = successData;
        this.show();
    }

    show() {
        this.element.style.display = "block";
    }

    hide() {
        this.element.style.display = "none";
    }

    onPrimaryButtonClick() {
        window.location.href = this.successData.links.account;
    }

    onSecondaryButtonClick() {
        // ссылка для перехода в приложение
        if (this.secondaryBtn.dataset.link !== undefined) {
            window.location.href = this.secondaryBtn.dataset.link;
        } else {
            window.location.href = this.successData.links.files;
        }
    }
}
